import React, { useState } from 'react';
import { Button, Modal } from '@/components/ui';

interface SubmissionConfirmationModalProps {
  show: boolean;
  referenceNumber: string;
  attachmentCount: number;
  onClose: () => void;
  onViewApprovals: () => void;
}

const SubmissionConfirmationModal: React.FC<SubmissionConfirmationModalProps> = ({
  show,
  referenceNumber,
  attachmentCount,
  onClose,
  onViewApprovals,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referenceNumber);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="sm" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Submitted for approval</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="tw-mb-1 tw-font-display tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-content-muted">
          Ticket number
        </p>
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
          <code
            className="tw-rounded tw-border tw-border-line tw-bg-surface-alt tw-px-3 tw-py-2 tw-font-mono tw-text-base tw-font-semibold tw-text-content tw-tabular-nums"
            data-testid="he-reference-number"
            aria-label={`Ticket number ${referenceNumber}`}
          >
            {referenceNumber}
          </code>
          <Button type="button" variant="outline-primary" size="sm" onClick={handleCopy}>
            {copied ? 'Copied' : 'Copy'}
          </Button>
        </div>
        <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-text-content">
          Quote this ticket number if you call the office or follow up on approval status.
        </p>
        {attachmentCount > 0 && (
          <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-text-content-muted">
            {attachmentCount} attachment{attachmentCount === 1 ? '' : 's'} uploaded to storage.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="outline-secondary" onClick={onClose}>
          Done
        </Button>
        <Button type="button" variant="primary" onClick={onViewApprovals}>
          View in Submissions
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubmissionConfirmationModal;
